import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header'
import Banner from '../service/Banner'
import { Col, Container, Row } from 'react-bootstrap'
import SectionHeader from '../sectionHeader'
import SectionSubHeader from '../sectionSubHeader'
import { SoftwareIcon } from '../../assets/svg'
import { IoCheckbox } from "react-icons/io5";
import Footer from '../../layouts/Footer'
import JoinOurTeam from '../Home/JoinOurTeam'
import { motion } from "motion/react";
import { Helmet } from 'react-helmet';

const Industry = ({data}) => {

     const [hasLoaded, setHasLoaded] = useState(false);
    
      useEffect(() => {
        window.scroll({
          top: 0,
          behavior: "smooth",
        });
        const timer = setTimeout(() => setHasLoaded(true), 100); 
        return () => clearTimeout(timer); 
      }, []);

  return (
        <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: hasLoaded ? 1 : 0 }}
        transition={{ duration: 0.7}}>
                  <Helmet>
        <title>Volto Consulting | Business &amp; Technology Solutions</title>
        <meta
          name="description"
          content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
        />
        <meta
          name="keywords"
          content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
        />
         <meta name="author" content="Volto Consulting" />
         <meta property="og:title" content="Volto Consulting | Business &amp; Technology Solutions" />
         <meta
          property="og:description"
          content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
        />
      </Helmet>
      
    <div className=' industry'>
        <Header mode={data.mode} />
         {/* Banner */}
    <Banner 
    mode={data.mode}
    bannerImg={data.bannerImg}
    title={data.industry_name}
    main_content={data.main_content}
    />
         <Container className='volto-section page-type-industries'>
            <Row>
                <Col lg={8} className='position-relative'>
                <SectionHeader mainText1={data.industry_name}  />
                <SectionSubHeader headerText={data.title} />
                 <p className='industry-subtext mt-4 text-justify'>{data.content}</p>
                </Col>
                <Col lg={4} className='position-relative'>
                 
                 <div className='descrption-card'>
                    <div className='descrption-details'>
                        <p><SoftwareIcon /> {data.card_title}</p>
                        <h4>{data.percentage}<span>%</span></h4>
                        <h6>{data.card_content}</h6>
                    </div>
                    <img className='' src="/images/industry-vector.png" alt="industry-card" />
                 </div>
                
                </Col>
            </Row>
         </Container>
         <Container className='volto-section'>
            <Row>
                <Col lg={5} className='tab-none-industry'>
                 <img className='img-fluid h-100 mt-lg-4 mb-lg-0 mb-4' src={data.image} alt="banking-approch" />
                </Col>
                <Col lg={7}>
                       <div className='industry-approach'>
                       <SectionHeader mainText1={"Our"} mainText2={"Approach"} />
                       <SectionSubHeader headerText={data.our_approach_title} />
                       <p className='industry-subtext mt-4'>{data.our_approach_content}</p>

                       <Row className='approach-section'>
                            {
                           Array.isArray(data.approaches) && data.approaches.map((item, index)=>(

                                    <Col lg={6} md={6} key={index} className='mb-4'>
                                        <img src={item?.image} alt={`approach-`+index } />
                                        <h3>{item?.main} <span>{item?.sub}</span></h3>
                                    </Col>
                                )
                            )
                           } 
                       
                       </Row>

                       </div>
                </Col>
            </Row>
         </Container>
         <Container className='volto-section' >
            <div className='our-offerings'>

            <Row className='offerings-row'>
            <Col lg={{span: 5}}>
                <SectionHeader mainText1={"Our "} mainText2={"Offerings"} />
                <SectionSubHeader headerText={data.Offerings_title} />
                <p className='industry-subtext mt-4'>{data.Offerings_content}</p>
                <div className='offerings-list'>
                {Array.isArray(data.OfferList) && data.OfferList.map((offers, index) => (
                    <p key={index}><IoCheckbox color='#0072DB' />&nbsp;&nbsp;{offers}</p>
                ))}
               </div>
            </Col>
            <Col className='tab-none-industry' lg={{span: 5}}>
                <img className='img-fluid ' src={data.offerings_image} alt="offerings" />
            </Col>
            </Row>
            </div>
           


         </Container>
          <div className='volto-section'>
         <JoinOurTeam image={'/images/confident-student.webp'} />

          </div>
         <Footer />
        
    </div> 
    </motion.div>
  )
}

export default Industry